import React, { useState, useEffect } from "react";
import axios from "axios";
import "./Dashboard.css";
import { FaHome, FaUser, FaSignOutAlt } from "react-icons/fa";
import { useNavigate } from "react-router-dom";

const Dashboard = () => {
  const [user, setUser] = useState();
  // const [recentGames, setRecentGames] = useState([]);
  const navigate = useNavigate();

const [games, setGames] = useState([]);
  const [recentGames, setRecentGames] = useState([]);

  // ---------- FETCH DATA ON LOAD ----------
  useEffect(() => {
    const fetchGames = async () => {
      try {
        const res = await axios.get("https://sattawalaonline.com/api/data");
        const data = res.data;

        if (Array.isArray(data)) {
          // Convert API fields into form structure
          const formatted = data.map((g) => ({
            id: g.id,
            title: g.heading,
            location: g.place,
            status: g.data,
          }));

          setGames(formatted);
          setRecentGames(data);
        }
      } catch (err) {
        console.error("Error fetching games:", err);
      }
    };

    fetchGames();
  }, []);

  // ---------- HANDLE CHANGE ----------
  const handleChange = (index, field, value) => {
    setGames((prevGames) =>
      prevGames.map((game, i) =>
        i === index ? { ...game, [field]: value } : game
      )
    );
  };

  // ---------- SAVE / UPDATE GAME ----------
  const saveGame = async (game) => {
    if (!game.id) return alert("Game ID missing!");

    try {
      const res = await axios.put(`https://sattawalaonline.com/api/data/${game.id}`, {
        heading: game.title,
        place: game.location,
        data: game.status,
      });

      alert(`Game "${game.location}" updated successfully!`);
      console.log("Updated:", res.data);
    } catch (err) {
      console.error("Error updating game:", err);
      alert("Error updating game");
    }
  };

    // ---------- LOGOUT ----------
  const handleLogout = () => {
    localStorage.removeItem("token"); // remove saved token
    alert("You have been logged out!");
    navigate("/login"); // redirect to login page
  };


  return (
    <div className="sattaDashboard">
      <aside className="sattaSidebar">
        <ul className="sattaMenu">
          <li className="active">
            <FaHome /> <span>Dashboard</span>
          </li>
          {/* <li>
            <FaUser /> <span>Profile</span>
          </li> */}
        </ul>
      </aside>

    <main className="sattaMain">
      <header className="sattaHeader">
        <h1>Hey, Welcome!</h1>
        <div className="dashboard-logout" onClick={handleLogout}>
          <FaSignOutAlt /> <span>Logout</span>
        </div>
      </header>

      <section className="sattaAddGame">
        <h2>Add / Update Game Activity</h2>

        {games.map((game, index) => (
          <div className="sattaAddGame-form" key={game.id}>
            <input
              type="text"
              name="title"
              placeholder="Satta Wala Live Result Today"
              value={game.title}
              onChange={(e) => handleChange(index, "title", e.target.value)}
            />
            <input
              type="text"
              name="location"
              placeholder="Game Location"
              value={game.location}
              onChange={(e) => handleChange(index, "location", e.target.value)}
            />
            <input
              type="text"
              name="status"
              placeholder="WAIT"
              value={game.status}
              onChange={(e) => handleChange(index, "status", e.target.value)}
            />
            <button onClick={() => saveGame(game)}>Save</button>
          </div>
        ))}
      </section>

      {/* Recent Games */}
      <section>
        <h2>Recent Games</h2>
        <ul>
          {recentGames.map((g) => (
            <li key={g.id}>
              {g.heading} - {g.place} - {g.data}
            </li>
          ))}
        </ul>
      </section>
    </main>
    </div>
  );
};

export default Dashboard;
